// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Star = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 30 32",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M29.714 11.554c0 .321-.232.625-.464.857l-6.482 6.321 1.536 8.929c.018.125.018.232.018.357 0 .464-.214.893-.732.893-.25 0-.5-.089-.714-.214l-8.018-4.214-8.018 4.214c-.232.125-.464.214-.714.214-.518 0-.75-.429-.75-.893 0-.125.018-.232.036-.357l1.536-8.929-6.5-6.321c-.214-.232-.446-.536-.446-.857 0-.536.554-.75 1-.821l8.964-1.304 4.018-8.125c.161-.339.464-.732.875-.732s.714.393.875.732l4.018 8.125 8.964 1.304c.429.071 1 .286 1 .821z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Star);
export default ForwardRef;
